var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"far fa-fw",class:{
        'm-disabled': _vm.disabled,
        'm-click': !_vm.disabled,
        'fa-lock text-warning': _vm.isChecked,
        'fa-lock-open text-muted': !_vm.isChecked
    },on:{"click":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }